/* PackIndex (narcis) — class-name contract implementation for @core/packs/PackIndex.
 * Minimal, text-only: no cards, no images. Matches the design tokens in
 * app/products/narcis/styles/partials/colors.scss (--bg/--surface/--text/--border/--yolk). */

.root {
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 32px 48px;

  @media (max-width: 900px) {
    padding: 0 20px 40px;
  }
}

.summary {
  cursor: pointer;
  font-family: var(--font-body);
  font-size: 14px;
  font-weight: 600;
  color: var(--text-muted);
  padding: 12px 0;
  list-style: none;
  user-select: none;

  &::-webkit-details-marker {
    display: none;
  }

  &::before {
    content: '+';
    display: inline-block;
    width: 1em;
    color: var(--yolk);
  }

  .root[open] > &::before {
    content: '\2212';
  }

  &:hover {
    color: var(--text);
  }
}

.groups {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(220px, 1fr));
  gap: 24px 32px;
  padding-top: 12px;
  border-top: 1px solid var(--border);
}

.group {
  min-width: 0;
}

.groupTitle {
  font-family: var(--font-body);
  font-size: 11px;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.04em;
  color: var(--text-dim);
  margin: 0 0 8px;
}

.list {
  list-style: none;
  margin: 0;
  padding: 0;
  display: flex;
  flex-direction: column;
  gap: 4px;
}

/* No per-link `class` is rendered (pack-index, 2026-08-30 — see PackIndex.tsx's own comment
   on why): style every anchor via this descendant selector instead of a `.link` class. */
.list a {
  font-family: var(--font-body);
  font-size: 13px;
  color: var(--text-muted);
  text-decoration: none;

  &:hover {
    color: var(--yolk);
    text-decoration: underline;
  }
}
